import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import FeaturesSection from '@/components/feature/FeaturesSection';
import AISection from '@/components/feature/AISection';
import DashboardSection from '@/components/feature/DashboardSection';
import SolutionsSection from '@/components/feature/SolutionsSection';
import IntegrationSection from '@/components/feature/IntegrationSection';
import DemoSection from '@/components/feature/DemoSection';
import BlogSection from '@/components/feature/BlogSection';
import ChatWidget from '@/components/feature/ChatWidget';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AISection />
        <DashboardSection />
        <SolutionsSection />
        <IntegrationSection />
        <DemoSection />
        <BlogSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
